module.exports = __webpack_public_path__ + "fonts/Canela-Regular.2d46e28.woff2";